/**
 * @generated SignedSource<<02adf61b0527bb023e5e290ba8a78485>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WorkspaceBreadcrumbs_workspaces$data = ReadonlyArray<{
  readonly id: string;
  readonly name: string;
  readonly parentId: string | null;
  readonly " $fragmentType": "WorkspaceBreadcrumbs_workspaces";
}>;
export type WorkspaceBreadcrumbs_workspaces$key = ReadonlyArray<{
  readonly " $data"?: WorkspaceBreadcrumbs_workspaces$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceBreadcrumbs_workspaces">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "WorkspaceBreadcrumbs_workspaces",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "parentId",
      "storageKey": null
    }
  ],
  "type": "Workspace",
  "abstractKey": null
};

(node as any).hash = "24c375cca13e0b73e9c411908df0da26";

export default node;
